import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import Header from "./Component/header/Header";
import Footer from "./Component/footer/Footer";
import Home from "./Component/home/Home";
import Details from "./Component/details/Details";
import PageNotFound from "./Component/404/PageNotFound";
import SearchResult from "./Component/searchresult/SearchResult";
import Explore from "./Component/details/explore/Explore";

import { FetchApi } from './Component/api/FetchApi';
import { setGenere, setUrl } from './Component/store/HomeSlice';

function App() {
  const dispatch = useDispatch();

  // 1. Function ko useCallback mein wrap karein aur useEffect se pehle define karein
  const genresCall = useCallback(async () => {
    const promises = [];
    const endpoints = ["tv", "movie"];
    const allGenres = {};

    endpoints.forEach((url) => {
      promises.push(
        FetchApi(`/genre/${url}/list`)
          .then((res) => res.json())
      );
    });

    const data = await Promise.all(promises);

    data?.forEach(({ genres }) => {
      genres?.forEach((item) => {
        allGenres[item.id] = item;
      });
    });

    dispatch(setGenere(allGenres));
  }, [dispatch]);

  // 2. Configuration fetch karne ke liye (Images base URL wagera)
  const fetchConfig = useCallback(() => {
    FetchApi("/configuration")
      .then((res) => res.json())
      .then((res) => {
        const url = {
          backdrop: res.images.secure_base_url + "original",
          poster: res.images.secure_base_url + "original",
          profile: res.images.secure_base_url + "original",
        };
        dispatch(setUrl(url));
      });
  }, [dispatch]);

  // 3. useEffect ke andar functions call karein
  useEffect(() => {
    fetchConfig();
    genresCall();
  }, [fetchConfig, genresCall]);

  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/:mediaType/:id' element={<Details />} />
        <Route path='/search/:query' element={<SearchResult />} />
        <Route path='/explore/:mediaType' element={<Explore />} />
        <Route path='*' element={<PageNotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;